import styled from 'styled-components';

// Three segment cards (48px) plus the gaps between them
const EXCLUDED_SEGMENTS_MAX_HEIGHT = 136;

export const BoxGroupStyled = styled.div`
  .boxGroup {
    &__box {
      border-radius: 8px;
      overflow: hidden;
    }

    /* BoxV2 only takes theme colors and none matches the design one, so it is set here.
       The extra class beats the BoxV2 styled-components rules */
    &__header.boxHeader {
      background-color: var(--color-sonata-primary-300);
      border-bottom-color: var(--color-sonata-primary-500);
      border-radius: 8px 8px 0 0;
    }

    &__body.boxBody__container {
      background-color: var(--color-sonata-primary-300);
      border-radius: 0 0 8px 8px;
      display: flex;
      flex-direction: column;
      gap: var(--spacing-8);
    }

    &__title {
      color: var(--color-sonata-primary-700);
      font: var(--font-body-400-medium);
    }

    &__headerRight {
      align-items: center;
      display: flex;
      gap: var(--spacing-8);
    }

    &__segmentsCounter {
      color: var(--color-sonata-primary-600);
      font: var(--font-body-400-regular);
      white-space: nowrap;

      strong {
        font: var(--font-body-400-bold);
      }
    }

    &__emptyState {
      color: var(--color-sonata-primary-500);
      font: var(--font-info-600-bold);
      padding: var(--spacing-16) 0;
      text-align: center;
    }

    &__segmentContainer {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-8);

      &--scroll {
        max-height: ${EXCLUDED_SEGMENTS_MAX_HEIGHT}px;
        overflow-y: auto;
      }
    }

    &__segment {
      align-items: center;
      background-color: var(--color-sonata-secondary-white);
      border: 1px solid var(--color-sonata-primary-400);
      border-radius: 8px;
      box-sizing: border-box;
      display: flex;
      flex-shrink: 0;
      gap: var(--spacing-8);
      min-height: 48px;
      padding: var(--spacing-8) var(--spacing-16);
    }

    &__segmentContent {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      min-width: 0;
    }

    &__segmentTitle {
      align-items: baseline;
      display: flex;
      gap: var(--spacing-4);
      min-width: 0;
      white-space: nowrap;
    }

    &__segmentName {
      color: var(--color-sonata-primary-800);
      font: var(--font-body-400-bold);
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__segmentCategory {
      color: var(--color-sonata-primary-600);
      flex-shrink: 0;
      font: var(--font-info-600-bold);
    }

    &__segmentInfo {
      align-items: center;
      color: var(--color-sonata-primary-600);
      display: flex;
      font: var(--font-info-500-regular);
      gap: var(--spacing-4);
      min-width: 0;
      overflow: hidden;
      white-space: nowrap;

      strong {
        font: var(--font-info-500-bold);
      }
    }

    &__segmentInfoSeparator {
      align-self: stretch;
      border-left: 1px solid var(--color-sonata-primary-600);
      margin: 2px 0;
    }

    &__deleteSegment,
    &__deleteGroup {
      background: none;
      border: none;
      color: var(--color-sonata-interaction-500);
      cursor: pointer;
      padding: 0;

      &:hover {
        color: var(--color-sonata-interaction-700);
      }
    }

    &__deleteSegment {
      flex-shrink: 0;
      font-size: 16px;
      height: 16px;
      line-height: 16px;
      width: 16px;
    }

    &__deleteGroup {
      align-items: center;
      align-self: center;
      display: flex;
      font: var(--font-interaction-500-semi-bold);
      gap: var(--spacing-4);

      i {
        font-size: 14px;
      }
    }
  }
`;

export const OrAndStyled = styled.div`
  align-items: center;
  display: flex;
  gap: var(--spacing-12);
  margin: var(--spacing-8) 0;
  width: 100%;

  .orAndContainer {
    &__orAndText {
      color: var(--color-sonata-primary-600);
      font: var(--font-info-600-medium);
      text-transform: uppercase;
      white-space: nowrap;
    }

    &__line {
      background-color: var(--color-sonata-primary-400);
      flex: 1 1 0;
      height: 1px;
    }
  }
`;
